import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actionCreators } from "../../store/KPI";
import { bindActionCreators } from "redux";
import DisplayUserKPI from "./DisplayUserKPI";
import KPISettings from "./KPISettingsMenu";

class BaseLayout extends Component {
    constructor(props) {
        super(props);

        this.state = {
            settingsMenu: false
        };

        this.onToggle = this.onToggle.bind(this);
    }

    componentDidMount() {
        if (this.props.kpi.options.length === 0) {
            this.props.getOptions();
        }
    }

    onToggle(event) {
        if (this.state.settingsMenu === true) {
            this.setState({ settingsMenu: false });
        } else {
            this.setState({ settingsMenu: true });
        }
    }

    render() {
        return (
            <div className="flex-container flex-column">
                <div className="flex-row kpi-settings-bar">
                    <div className="settings-bar-item">
                        <button type="button" name="button"
                            onClick={this.onToggle}
                        >
                            <span className={this.state.settingsMenu ? "icon-dashboard-dark-48" : "icon-settings-dark-48"} />
                        </button>
                    </div>
                </div>
                {this.state.settingsMenu ? <KPISettings /> : <DisplayUserKPI history={this.props.history} />}
            </div>
        );
    }
}


export const mapStateToProps = function (state) {
    return {
        user: state.oidc.user,
        kpi: state.kpi,
        options: state.kpi.options
    }
};

export default connect(
    mapStateToProps,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(BaseLayout);